import React, { useState } from 'react'

import { isNotPast } from '../../utils/isNotPast'
import LargeRectangleModal from '../LargeRectangleModal/LargeRectangleModal'

import { StyledBlockText, StyledColoredContainer, StyledProductHighlight } from './LargeRectangleBlocs.styled'
import LargeRectangleBloc from '../LargeRectangleBloc/LargeRectangleBloc'
import { getBrowser, getMobileSystem } from '../../utils/UserAgentInformations'
import useMediaQuery from '../../hooks/useMediaQuery'
import { deviceMax } from '../../theme/breakpoints'

const LargeRectangleBlocs = ({hasMargin = true,largesRectangles, locale, location}) => {

  const [tappedCard, setTappedCard] = useState(null)
  const [show, setShow] = useState(false)
  const isMobile = useMediaQuery(deviceMax.mobileL)
  const browser = getBrowser()
  const mobileSystem = getMobileSystem()

  //Check if one or multiples LargesRectangles
  const highlights =
    largesRectangles && largesRectangles.length > 0 ? (
      largesRectangles.filter(isNotPast).map((highlight, index) => {
        const isPair = index % 2 === 0
        return (
          <StyledColoredContainer
            key={index + 'coloredContainer'}
            $isPair={isPair}
          >
            <StyledBlockText>
              <LargeRectangleBloc
                highlight={highlight}
                index={index}
                setTappedCard={setTappedCard}
                setShow={setShow}
                locale={locale}
                mobileSystem={mobileSystem}
                browser={browser}
                location={location}
                hasMargin={hasMargin}
              />
            </StyledBlockText>
          </StyledColoredContainer>
        )
      })
    ) : (
      <LargeRectangleBloc
        highlight={largesRectangles}
        index={0}
        setTappedCard={setTappedCard}
        setShow={setShow}
        locale={locale}
        mobileSystem={mobileSystem}
        browser={browser}
        location={location}
        hasMargin={hasMargin}
      />
    )

  return (
    <>
      {highlights && (
        <StyledProductHighlight>{highlights}</StyledProductHighlight>
      )}
      <LargeRectangleModal
        show={show}
        isMobile={isMobile}
        onClose={() => {
          setShow(false)
        }}
        card={tappedCard}
      />
    </>
  )
}
export default LargeRectangleBlocs
